import React, { useState, useEffect, createContext } from "react";
import decode from "jwt-decode";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import axios from "axios";

// api services
import { AuthService } from "../services/";

const AuthContext = createContext({});

const Provider = ({ children }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loginNumberError, setLoginNumberError] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [OTPNumberError, setOTPNumberError] = useState(false);
  const [OTPLoading, setOTPLoading] = useState(false);
  const [loginStage, setLoginState] = useState(null);
  const [OTPCode, setOTPCode] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [expiryOTPCountdown, setExpiryOTPCountdown] = useState(0);

  const history = useHistory();

  useEffect(() => {
    getPhoneNumberFromStorage();
    getTokenFromStorage();
    getPhoneNumberfromToken();
  }, []);

  async function checkLogin() {
    try {
      const isLoggedIn = localStorage.getItem("isLoggedIn");

      const hasSentCode = localStorage.getItem("sentCode");
      const hasVerifiedPhoneNumber = localStorage.getItem(
        "hasVerifiedPhoneNumber"
      );
      const IsNewUser = localStorage.getItem("isNewUser");

      switch (true) {
        case isLoggedIn === "isLoggedIn":
          history.push(`/home`);
          break;

        case hasVerifiedPhoneNumber === "true" && IsNewUser === "No":
          history.push(`/home`);
          break;

        case hasVerifiedPhoneNumber === "true" && IsNewUser === "Yes":
          setLoginState("UserInfoScreen");
          break;

        case hasSentCode === "sentCode":
          setLoginState("OTPScreen");
          break;

        default:
          setLoginState("LoginScreen");
          history.push(`/login`);
          break;
      }
    } catch (e) {}
  }

  async function checkAuth(token, gps) {
    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
      localStorage.setItem("gps", JSON.stringify(gps));
    } else {
      history.push(`/login`);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        sendOTP,
        phoneNumber,
        setPhoneNumber,
        loginNumberError,
        loginLoading,
        loginStage,
        setLoginState,
        resendOTPCode,
        OTPNumberError,
        OTPLoading,
        verifyCode,
        setOTPCode,
        userDetails,
        expiryOTPCountdown,
        setExpiryOTPCountdown,
        getExpiryOTPCountdown,
        checkLogin,
        checkAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );

  async function getExpiryOTPCountdown() {
    const otpexpiry = localStorage.getItem("otpexpiry");

    if (otpexpiry) {
      const parsedExpiry = parseInt(otpexpiry);

      const expiry = parsedExpiry - new Date().getTime();

      if (expiry > 0) {
        setExpiryOTPCountdown(parseInt(expiry / 1000));
      } else {
        setExpiryOTPCountdown(0);
      }
    }
  }

  async function getPhoneNumberFromStorage() {
    const msisdn = localStorage.getItem("phoneNumber");

    if (msisdn) {
      setPhoneNumber(msisdn);
    }

    return msisdn;
  }

  function updateHttpHeaders(token) {
    const commons = axios.defaults.headers.common;
    if (token) {
      commons.Authorization = `Token ${token}`;
      getPhoneNumberFromStorage();
    }
  }

  async function getTokenFromStorage() {
    const token = localStorage.getItem("token");
    updateHttpHeaders(token);
  }

  async function getPhoneNumberfromToken() {
    const token = localStorage.getItem("token");
    const decoded = decode(token);
    if (token && decoded) {
      setPhoneNumber(decoded?.msisdn);
    }
  }

  async function resendOTPCode() {
    try {
      await sendOTP(phoneNumber);

      setOTPCode("");

      getExpiryOTPCountdown();
    } catch (e) {}
  }

  async function sendOTP(msisdn) {
    if (msisdn?.length !== 10) {
      return;
    }

    try {
      setLoginLoading(true);

      const { data } = await AuthService.sendOTPCode(msisdn?.substring(1, 10));

      const { data: result, success } = data;

      setLoginLoading(false);

      if (success) {
        setLoginNumberError(false);

        if (success && result.SERVICE_CODE === "PREPAID") {
          localStorage.setItem("sentCode", "sentCode");
          localStorage.setItem("phoneNumber", msisdn);

          const expiry = new Date().getTime() + 60 * 1000;

          localStorage.setItem("otpexpiry", JSON.stringify(expiry));

          setPhoneNumber(msisdn);

          setLoginState("OTPScreen");
        }
      } else {
        setLoginNumberError(true);
      }
    } catch (e) {
      setLoginNumberError(false);
      setLoginLoading(false);
    }
  }

  async function verifyCode() {
    try {
      setOTPLoading(true);

      const { success, data } = await AuthService.verifyOTPCode({
        msisdn: phoneNumber,
        code: OTPCode,
      });

      setOTPLoading(false);

      if (success) {
        try {
          const { token, isNew, userDetails } = data;

          localStorage.setItem("hasVerifiedPhoneNumber", "true");

          localStorage.setItem("token", token);

          updateHttpHeaders(token);

          const { data: userInfo } = userDetails;

          localStorage.setItem("userDetails", JSON.stringify(userInfo));

          setUserDetails(userInfo);

          if (isNew) {
            localStorage.setItem("isNewUser", "Yes");

            setLoginState("UserInfoScreen");
          } else {
            localStorage.setItem("isNewUser", "No");

            localStorage.setItem("isLoggedIn", "isLoggedIn");

            history.push(`/home`);
          }
        } catch (e) {
          setOTPNumberError(true);
        }
      }
    } catch (e) {
      setOTPLoading(false);
      setOTPNumberError(true);
    }
  }
};

AuthContext.ProviderWrapper = Provider;

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
